import { Controller } from "@hotwired/stimulus"

// Opens a scrollable box at its newest content — the client page's WhatsApp
// transcript, which reads oldest-first.
//
// The panel starts hidden (display:none), where scrollHeight is 0, so scrolling
// on connect alone does nothing. An IntersectionObserver waits until the tab is
// actually shown; it fires whatever caused the reveal, so this stays decoupled
// from the tabs controller.
export default class extends Controller {
  connect() {
    this.scrollToBottom()

    if (!("IntersectionObserver" in window)) return
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        this.scrollToBottom()
        // Only the first reveal is automatic: after that the reader's own
        // scroll position is theirs to keep.
        this.observer.disconnect()
        this.observer = null
      })
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
  }

  scrollToBottom() {
    this.element.scrollTop = this.element.scrollHeight
    // Again next frame for images and fonts that lay out after this tick.
    requestAnimationFrame(() => {
      this.element.scrollTop = this.element.scrollHeight
    })
  }
}
